<div class="grid card-wrapper">
  <div class="md:col-5 sm:col-12">
    <div class="font-bold mt-2">{{ 'taxo.searchCategory' | translate }}</div>
    <div>
      <div style="height: calc(100vh - 320px)">
          <p-tree
          [scrollHeight]="'calc(100vh - 360px)'"
          [value]="categories"
          [filter]="true"
          [loading]="loading"
          emptyMessage="{{'primeng.emptyMessage' | translate}}"
          filterBy="categoryLabelLoc"
          selectionMode="single"
          [(selection)]="selectedNode"
          (onNodeSelect)="onNodeSelected($event)">
          <ng-template let-node pTemplate="default">
            <div>
              @if (node?.hasChildren == 'false') {
                <div class="typology">
                  <i class="pi pi-bookmark"></i>
                  <span class="p-ml-2">{{ node.categoryLabelLoc }}</span>
                  <span>-</span>
                  <div style="display: flex; align-items: center;">
                    <span style="color: grey;">{{node.categoryId}}</span>
                    <p-button
                      icon="pi pi-copy"
                      [text]="true"
                      severity="secondary"
                      iconPos="right"
                      ngxClipboard
                      [cbContent]="node.categoryId"
                      #copyButton
                      (click)="toggleTooltip()"
                      [pTooltip]="showTooltip ? 'copié  &#10003;' : null"
                      [tooltipPosition]="'right'"
                      tooltipEvent="focus">
                    </p-button>
                  </div>
                
                </div>
              } @else {
                <span class="p-ml-2" style="font-size: 12px">{{ node.categoryLabelLoc }} - </span><span style="color: grey;">{{node.categoryId}}</span>
              }
            </div>
          </ng-template>
        </p-tree>
      </div>
    </div>
  </div>
  <div class="md:col-7 sm:col-12">
    <div class="flex right">
      <div class="font-bold mt-2" style="margin-bottom: 13px">{{ "taxo.attributeList" | translate }}</div>
    </div>
    <p-panel [toggleable]="attributeSize > 0" [collapsed]="isCollapsed">
      <ng-template pTemplate="header">
        <div class="flex gap-2 align-items-center">
          <span class="font-bold">{{'global.attributes' | translate}}</span>
          <p-tag severity="info"> {{ attributeSize }} {{'global.attributes' | translate}} </p-tag>
        </div>
      </ng-template>
      <ng-template pTemplate="body">
        @if (attributeSize > 0) {
          <p-table
            [value]="attributes"
            [scrollable]="true"
            selectionMode="single"
            [rowHover]="true"
            [scrollHeight]="'calc(100vh - 365px)'"
            [rows]="5"
            [rowsPerPageOptions]="[5, 10, 20]">
            <ng-template pTemplate="header">
              <tr>
                @for (header of headers; track $index) {
                  <th [pSortableColumn]="header.id" style="font-size: 0.9rem; font-weight: 700" [id]="header.id">
                    <span>{{ header.value | translate}}</span>
                    <p-sortIcon [field]="header.id" />
                  </th>
                }
                <!-- TODO IDFX-416 -->
                <!-- <th></th> -->
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-attribute>
              <tr style="cursor: pointer">
                @for (header of headers; track $index) {
                  <td>
                    {{ attribute[header.id] | translate}}
                  </td>
                }
                <!-- TODO IDFX-416 -->
                <!-- <td>
                  <p-button [text]="true" icon="pi pi-eye" (click)="handleAttributeClick(attribute)"></p-button>
                </td> -->
              </tr>
            </ng-template>
          </p-table>
        }
      </ng-template>
    </p-panel>
  </div>
</div>
